<div class="agent-body h-100 d-flex flex-column justify-content-between m-3">
  <div class="agent-header d-flex flex-row justify-content-between align-items-center">
    <div class="agent-toolbar-left">
      <!-- Pagination info -->
      <span class="pagination-info">
        <strong>{{ paginationStart }}</strong>
        <span class="pagination-sep">&nbsp;-&nbsp;</span>
        <strong>{{ paginationEnd }}</strong>
        <span class="pagination-sep">&nbsp;of&nbsp;</span>
        <strong>{{ paginationTotal }}</strong>
      </span>

      <!-- Prev / Next arrows -->
      <div class="page-nav-group">
        <button
          class="page-nav-btn"
          title="Previous page"
          [disabled]="currentPage === 1"
          (click)="prevPage()"
        >
          <span class="chevron chevron--left"></span>
        </button>
        <button
          class="page-nav-btn"
          title="Next page"
          [disabled]="paginationEnd >= paginationTotal"
          (click)="nextPage()"
        >
          <span class="chevron chevron--right"></span>
        </button>
      </div>

      <!-- Vertical separator -->
      <div class="toolbar-separator"></div>

      <!-- Filter icon -->
      <button
        class="agent-icon-btn"
        [class.agent-icon-btn--active]="hasActiveFilters"
        title="Filter"
        (click)="openFilterModal()"
      >
        <img
          [src]="'images/virtusa-icons/filter.svg' | assetUrl"
          alt="Filter"
          width="18"
          height="18"
        />
        <span *ngIf="hasActiveFilters" class="filter-active-badge"></span>
      </button>

      <!-- Delete icon -->
      <button
        class="agent-icon-btn agent-icon-btn--delete"
        title="Remove selected"
        [disabled]="selectedAgentList.length === 0"
        [class.agent-icon-btn--disabled]="selectedAgentList.length === 0"
        (click)="openDeleteConfirmationModal()"
      >
        <img
          [src]="'images/virtusa-icons/trash.svg' | assetUrl"
          alt="Remove"
          width="16"
          height="18"
        />
      </button>
    </div>

    <div class="agent-toolbar-right">
      <button class="agent-btn-reclaim" (click)="reclaimAgent()">
        Reclaim
      </button>
      <button class="agent-btn-add" (click)="openGenericModal(false)">
        Add New Engines
      </button>
    </div>
  </div>

  <app-loading
    *ngIf="isLoading && !isIntervalLoading"
    [text]="'Loading'"
    class="h-100"
  ></app-loading>

  <div class="table-div h-100" *ngIf="!isLoading">
    <app-zorro-table
      #agentTable
      [columns]="columns"
      [data]="dataSource"
      [options]="tableOptions"
      (handleActions)="handleActionsInTable($event)"
      (onRowSelect)="handleRowSelect($event)"
      (pageChange)="onTablePageChange($event)"
    ></app-zorro-table>
  </div>
</div>
